// VORLICH — Find the Right Gift quiz. Config + catalog driven. Accessible, no deps.
(function () {
  var root = document.querySelector('.vp-quiz');
  if (!root) return;
  var cfg, prods;
  try {
    cfg = JSON.parse(document.getElementById('quizConfig').textContent);
    prods = JSON.parse(document.getElementById('quizProducts').textContent);
  } catch (e) { return; }

  var stage = root.querySelector('#quizStage'),
      progress = root.querySelector('#quizProgress'),
      backBtn = root.querySelector('#quizBack'),
      restartBtn = root.querySelector('#quizRestart'),
      cartAdd = root.getAttribute('data-cart-add');
  var step = 0, answers = [];

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return (s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderQuestion(i) {
    step = i;
    var q = cfg.questions[i];
    stage.innerHTML = '';
    progress.textContent = (cfg.copy.question || 'Question') + ' ' + (i + 1) + ' / ' + cfg.questions.length;
    var h = el('h2', 'quiz-q', esc(q.q)); h.id = 'quizHead'; h.setAttribute('tabindex', '-1');
    stage.appendChild(h);
    var list = el('div', 'quiz-opts');
    q.options.forEach(function (opt, oi) {
      var b = el('button', 'quiz-opt'); b.type = 'button';
      b.innerHTML = '<span>' + esc(opt.label) + '</span><span class="oi" aria-hidden="true">→</span>';
      if (answers[i] === oi) b.setAttribute('aria-pressed', 'true');
      b.addEventListener('click', function () { answers[i] = oi; advance(); });
      list.appendChild(b);
    });
    stage.appendChild(list);
    backBtn.hidden = (i === 0);
    restartBtn.hidden = false;
    h.focus();
  }

  function advance() { if (step < cfg.questions.length - 1) renderQuestion(step + 1); else renderResult(); }

  function rank() {
    var totals = {};
    cfg.questions.forEach(function (q, i) {
      var oi = answers[i]; if (oi == null) return;
      var sc = q.options[oi].scores || {};
      for (var k in sc) totals[k] = (totals[k] || 0) + sc[k];
    });
    var keys = Object.keys(prods).filter(function (k) { return prods[k]; });
    keys.sort(function (a, b) {
      var d = (totals[b] || 0) - (totals[a] || 0);
      if (d !== 0) return d;
      return cfg.tiebreak.indexOf(a) - cfg.tiebreak.indexOf(b);
    });
    return keys;
  }

  function card(key, label) {
    var p = prods[key];
    var media = p.img
      ? '<div class="qc-media"><img src="' + p.img + '" alt="' + esc(p.name) + '" loading="lazy" width="600" height="600"></div>'
      : '<div class="qc-media qc-ph"><span>' + esc(p.name) + '</span></div>';
    var reason = (cfg.reasons && cfg.reasons[key]) || '';
    var aqua = (key === 'GIFTBOX' && cfg.copy.aqua_note)
      ? '<p class="qc-aqua"><a href="' + p.url + '">' + esc(cfg.copy.aqua_note) + '</a></p>' : '';
    var action = p.available
      ? '<button type="button" class="qc-add" data-vid="' + p.vid + '">' + esc(cfg.copy.add) + '</button>'
      : '<span class="qc-sold">Sold out</span>';
    var c = el('div', 'quiz-card' + (label ? ' is-runner' : ''));
    c.innerHTML = (label ? '<div class="qc-label">' + esc(label) + '</div>' : '') + media +
      '<div class="qc-body">' +
        '<div class="qc-name">' + esc(p.name) + '</div>' +
        '<div class="qc-price">' + esc(p.price) + '</div>' +
        '<p class="qc-reason">' + esc(reason) + '</p>' +
        '<div class="qc-actions">' + action + '<a class="qc-view" href="' + p.url + '">' + esc(cfg.copy.view) + '</a></div>' +
        aqua +
      '</div>';
    return c;
  }

  function renderResult() {
    var order = rank();
    stage.innerHTML = '';
    progress.textContent = '';
    var wrap = el('div', 'quiz-result');
    var h = el('h2', 'quiz-rh', esc(cfg.copy.result_heading)); h.id = 'quizHead'; h.setAttribute('tabindex', '-1');
    wrap.appendChild(h);
    wrap.appendChild(card(order[0]));
    if (order[1]) wrap.appendChild(card(order[1], cfg.copy.runner_up));
    stage.appendChild(wrap);
    backBtn.hidden = false; restartBtn.hidden = false;
    stage.querySelectorAll('.qc-add').forEach(function (b) {
      b.addEventListener('click', function () { addToCart(b.getAttribute('data-vid')); });
    });
    h.focus();
  }

  function addToCart(vid) {
    var f = document.createElement('form'); f.method = 'post'; f.action = cartAdd;
    var i = document.createElement('input'); i.type = 'hidden'; i.name = 'id'; i.value = vid;
    f.appendChild(i); document.body.appendChild(f);
    if (f.requestSubmit) { f.requestSubmit(); } else { f.submit(); }
  }

  backBtn.addEventListener('click', function () {
    if (stage.querySelector('.quiz-result')) renderQuestion(cfg.questions.length - 1);
    else if (step > 0) renderQuestion(step - 1);
  });
  restartBtn.addEventListener('click', function () { answers = []; renderQuestion(0); });

  renderQuestion(0);
})();
